import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-common-page',
  templateUrl: './common-page.component.html',
  styleUrls: ['./common-page.component.scss']
})
export class CommonPageComponent implements OnInit {

  constructor() { }

  @Input() set id(id: string) {
    this._name =  id ;
  }
  // tslint:disable-next-line:variable-name
  public _name: string

  @Output() pageChange = new EventEmitter();

  ngOnInit() {
  }
  getData($event) {
    this.pageChange.emit($event);
  }

}
